import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';
import type { WorkspaceForex } from '@/domain/WorkspaceForex/WorkspaceForex.ts';

export function saveWorkspace(builder: WebapiEndpointBuilder) {
  return builder.mutation<void, WorkspaceForex>({
    query: (body) => {
      // make sure that every product has an associated tile
      const existingProducts = Object.fromEntries(
        Object.entries(body.products).map(([key, products]) => [
          key,
          products.filter((product) => {
            return body.tiles.find((tile) => tile.tileId === product.tileId) !== undefined;
          }),
        ]),
      );
      return {
        url: `/userdata/workspaceForex/${WORKSPACE_VERSION}`,
        method: 'POST',
        body: {
          ...body,
          products: existingProducts,
        },
      };
    },
  });
}
